module.exports = __webpack_public_path__ + "img/thestacks.im.2ff80179.png";